import React from 'react';
import Icon from './Icon';
import {IconProps} from './IconProps';


export default function IconError({className, height, title}: IconProps) {
  return (
    <Icon className={className} height={height} title={title}>
      M8.72143 2.59296C9.10985 2.36807 9.55146 2.25 10.0005 2.25C10.4495 2.25 10.8911 2.36807 11.2795 2.59296C11.6656
      2.81653 11.9859 3.138 12.206 3.52567L18.5161 14.2173C18.5342 14.248 18.5501 14.2799 18.5637 14.3128C18.7198
      14.6918 18.7793 15.1031 18.7366 15.5107C18.6938 15.9182 18.5503 16.3083 18.3195 16.647C18.0887 16.9857 17.7781
      17.2624 17.4156 17.4541C17.0531 17.6459 16.6493 17.7472 16.2392 17.75L16.234 17.75V17.75H3.78472C3.7684 17.75
      3.75221 17.7495 3.73615 17.7485C3.70747 17.7503 3.67838 17.7505 3.64898 17.749C3.24849 17.7288 2.85804 17.6147
      2.51017 17.4155C2.16224 17.2164 1.86651 16.9375 1.64864 16.6013C1.43072 16.265 1.29729 15.8814 1.26045
      15.4825C1.22361 15.0836 1.28454 14.6821 1.43768 14.3119C1.45116 14.2793 1.46692 14.2477 1.48484 14.2173L7.79491
      3.52572C8.01502 3.13803 8.33528 2.81654 8.72143 2.59296ZM3.73561 16.2516C3.75185 16.2505 3.76822 16.25 3.78472
      16.25H16.231C16.4004 16.2485 16.5663 16.2064 16.7142 16.1282C16.8627 16.0497 16.9879 15.9375 17.0798
      15.8025C17.1718 15.6675 17.228 15.5136 17.2447 15.3542C17.2599 15.21 17.2423 15.0642 17.1932 14.9271L10.9107
      4.2822L10.9032 4.26914C10.8158 4.11405 10.6867 3.98303 10.5279 3.89108C10.369 3.79907 10.1868 3.75 10.0005
      3.75C9.8141 3.75 9.63193 3.79907 9.47302 3.89108C9.31421 3.98303 9.18512 4.11405 9.09774 4.26914L9.09021
      4.2822L2.80739 14.9276C2.75921 15.0614 2.74107 15.2036 2.75409 15.3446C2.7685 15.5006 2.82076 15.6518 2.90745
      15.7856C2.99419 15.9195 3.11316 16.0323 3.25541 16.1138C3.39772 16.1952 3.55869 16.2425 3.72483 16.251L3.73561
      16.2516ZM9.25 11.5V6.5H10.75V11.5H9.25ZM9.25 13V14.5H10.75V13H9.25Z
    </Icon>
  );
}
